/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataStructureGraphIcon24Solid = forwardRef('DataStructureGraphIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2 6a4 4 0 0 1 4-4h8a4 4 0 0 1 0 8h-1.892l2.857 4H18a4 4 0 0 1 0 8h-8a4 4 0 0 1 0-8h1.892l-2.857-4H6a4 4 0 0 1-4-4Z" })));
});
